module.exports = __webpack_public_path__ + "img/title6_6.f373d6f5.png";